<script lang="ts">
  import { onMount } from "svelte";
  import Header from "./Header.svelte";
  import Footer from "./Footer.svelte";
  import ContactForm from "./ContactForm.svelte";
  import BetaCallout from "./BetaCallout.svelte";
  import { betaEnabled } from "./beta";
  import { pageById, partialFor } from "./pages";
  import { applyBehaviors } from "./behaviors";

  // Render the auto-generated shop partial verbatim, then append the live
  // "Kaufinteresse" form where the static page only had a dead CTA link.
  const meta = pageById["shop"];
  const html = partialFor("shop");

  let main: HTMLElement;
  let cleanup: (() => void) | null = null;

  onMount(() => {
    if (meta?.title) document.title = meta.title;
    let desc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.name = "description";
      document.head.appendChild(desc);
    }
    desc.content = meta?.description ?? "";
    window.scrollTo({ top: 0, behavior: "auto" });
    if (main) cleanup = applyBehaviors(main);
    return () => cleanup?.();
  });
</script>

<Header active="" />
<main bind:this={main}>
  {@html html}
  {#if $betaEnabled}
    <BetaCallout />
  {/if}
  <section class="section" style="padding-top:0">
    <div class="wrap" style="max-width:880px">
      <div class="prose" style="max-width:none">
        <h2 id="kaufinteresse">Kaufinteresse senden</h2>
        <p>
          Sag uns, welche Ausstattung du brauchst. Mit dem Senden gehst du
          keine Bestellung ein — du teilst uns nur dein Interesse mit. Wir
          erhalten deine Nachricht per E-Mail.
        </p>
        <ContactForm kind="shop" />
      </div>
    </div>
  </section>
</main>
<Footer />
